import { render } from "./GiftLoadButton.vue?vue&type=template&id=d514ddd4&scoped=true"
import script from "./GiftLoadButton.vue?vue&type=script&lang=js"
export * from "./GiftLoadButton.vue?vue&type=script&lang=js"

import "./GiftLoadButton.vue?vue&type=style&index=0&id=d514ddd4&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d514ddd4"]])

export default __exports__